import React from "react";
import {NotificationBodyStyled, NotificationStyled, NotificationTextContainerStyled, NotificationTitleStyled} from "./Notification.style";
import i18n from "../../i18n";
import {SvgMoreButtonArrowIcon} from "../../pages/result/ResultPage";

export default class Notification extends React.Component {
    containerRef = React.createRef();

    componentDidMount() {
        window.addEventListener("click", this.handleOutsideClick);
    }

    componentWillUnmount() {
        window.removeEventListener("click", this.handleOutsideClick);
    }

    handleOutsideClick = (e) => {
        if (this.containerRef && !this.containerRef.current.contains(e.target)) {
            this.props.handleCloseButtonClick();
        }
    }

    render() {
        const {preview, handleCloseButtonClick, handleNotificationClick} = this.props;

        return (
            <NotificationStyled ref={this.containerRef} onClick={handleNotificationClick}>
                <button
                    className="button-close-notification"
                    onClick={handleCloseButtonClick}>
                    <svg viewBox="0 0 16 16">
                        <path strokeWidth=".5" d="M.554 2.025L6.53 8 .554 13.976c-.405.405-.405 1.064 0 1.47.406.405 1.065.405 1.47 0L8 9.47l5.975 5.975c.406.406 1.065.406 1.47 0h0c.406-.405.406-1.064 0-1.47L9.47 8l5.976-5.976h0c.405-.405.405-1.064 0-1.47-.406-.405-1.065-.405-1.47 0 0 0 0 0 0 0L8 6.53 2.024.554C1.62.15.96.15.554.554.15.96.148 1.62.554 2.024c0 0 0 0 0 0z" />
                    </svg>
                </button>
                <NotificationTextContainerStyled>
                    <NotificationTitleStyled>{i18n.t("notification_title")}</NotificationTitleStyled>
                    <div>
                        <NotificationBodyStyled dangerouslySetInnerHTML={{__html: i18n.t("notification_text")}} />
                        <SvgMoreButtonArrowIcon />
                    </div>
                </NotificationTextContainerStyled>
                <video src={preview} />
            </NotificationStyled>
        )
    }
}